import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Slider,
  Box,
} from "@mui/material";

const EPaymentFeesDialog = ({
  open,
  onClose,
  onSubmit,
  ePaymentFeesData,
  setEPaymentFeesData,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth dir="rtl">
      <DialogTitle>تحديث عمولة الدفع الإلكتروني</DialogTitle>
      <DialogContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          النقطة: {ePaymentFeesData.name}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          العمولة الحالية: {(ePaymentFeesData.e_payment_fees * 100).toFixed(1)}%
        </Typography>
        <Slider
          value={(ePaymentFeesData.e_payment_fees * 100).toFixed(1)}
          onChange={(event, newValue) => {
            setEPaymentFeesData({
              ...ePaymentFeesData,
              e_payment_fees: newValue / 100,
            });
          }}
          min={0}
          max={2}
          step={0.1}
          valueLabelDisplay="on"
          valueLabelFormat={(value) => `${value}%`}
          sx={{ mt: 2, mb: 2 }}
        />
        <TextField
          type="number"
          label="عمولة الدفع الإلكتروني (%)"
          value={(ePaymentFeesData.e_payment_fees * 100).toFixed(1)}
          onChange={(e) => {
            const value = Math.max(
              0,
              Math.min(2, parseFloat(e.target.value) || 0)
            );
            setEPaymentFeesData({
              ...ePaymentFeesData,
              e_payment_fees: value / 100,
            });
          }}
          inputProps={{ min: 0, max: 2, step: 0.1 }}
          fullWidth
          sx={{ mt: 2 }}
        />
        <Box sx={{ mt: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <strong>أمثلة:</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            • 1% = 0.01 (الافتراضي)
          </Typography>
          <Typography variant="body2" color="text.secondary">
            • 1.5% = 0.015
          </Typography>
          <Typography variant="body2" color="text.secondary">
            • 2% = 0.02 (الحد الأقصى)
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            sx={{ mt: 2, fontWeight: "bold" }}
          >
            <strong>مثال حي:</strong> معاملة بقيمة 10,000 {`=>`} العمولة ={" "}
            {(ePaymentFeesData.e_payment_fees * 10000).toFixed(0)}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>إلغاء</Button>
        <Button onClick={onSubmit} variant="contained">
          تحديث
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EPaymentFeesDialog;
